export default {
  stylesheet: '/suitup.css',
  favicon: '/suitup_favicon.png',
  base_api_url: 'https://accounting.seasideapis.com/',
  images: {
    logo_bright: '/suitup_logo_bright.png',
    logo_dark: '/suitup_logo_dark.png'
  }
}
